<template>
  <div class="container"
       :style="'height:'+containerHeight+'px'">
    <a-carousel autoplay
                v-if="banner.length > 0">
      <div v-for="(item, index) in banner"
           :key="index">
        <img class="banner-img"
             :src="item.bannerUrl"
             alt="" />
      </div>
    </a-carousel>
    <div class="recommend-course">
      <div class="label flex-row-start">
        <span></span>{{recommendName}}
      </div>

      <div class="recommend">
        <div v-for="(item, index) in recommend"
             :key="index"
             @click="toDetails(item)"
             class="recommend-item">
          <img :src="item.imgUrl"
               alt="">
          <div class="content">
            <span class="goods-name">{{item.goodsName}}</span>
            <p class="remarks">{{item.goodsTitle}}</p>
            <div class="study flex-row-between">
              <span class="buy-number">{{item.peopleBuyNumber}}人已学习</span>
              <span class="money">￥{{item.goodsSellPrice}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="all-course">
      <div class="label flex-row-start">
        <span></span>{{allcourseName}}
      </div>

      <div class="flex-row-between course"
           v-if="allcourse.length > 0">
        <div class="left">
          <div :class="['nav','cursor-pointer',index == allCourseLeftNavSelect? 'navSelect' : '' ]"
               v-for="(item, index) in allcourse"
               :key="index"
               @click="leftSelectNav(index)">
            <span v-if="item.industryName.length > 8"
                  class="small-text-span"
                  @mouseover="spanHover(true)"
                  @mouseleave="spanHover(false)">{{item.industryName}}</span>
            <span v-else>{{item.industryName}}</span>
          </div>
        </div>
        <div class="right">
          <div class="top-nav">
            <span :class="[itemIndex == allCourseTopNavSelect ? 'top-nav-select' : '']"
                  v-for="(item, itemIndex) in allcourse[allCourseLeftNavSelect].goodsItemsList"
                  :key="itemIndex"
                  @focus="topSelectNav(itemIndex)"
                  @mouseover="topSelectNav(itemIndex) ">{{item.itemName}}</span>
          </div>
          <div :class="['recommend', infomation.length > 0? 'recommend3n':'recommend4n']">
            <div v-for="(item, index) in allcourse[allCourseLeftNavSelect].goodsItemsList[allCourseTopNavSelect].goodsList"
                 :key="index"
                 class="recommend-item"
                 @click="toDetails(item)">
              <img :src="item.imgUrl"
                   alt="">
              <div class="content">
                <span class="goods-name">{{item.goodsName}}</span>
                <p class="remarks">{{item.goodsTitle}}</p>
                <div class="study flex-row-between">
                  <span class="buy-number">{{item.peopleBuyNumber}}人已学习</span>
                  <span class="money">￥{{item.goodsSellPrice}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="infomation"
             v-if="infomation.length > 0">
          <h5>资讯</h5>
          <div class="item"
               v-for="(item, index) in infomation"
               :key="index"
               @click="toArticleDetails(item)">
            <div>{{item.articleTitle}}</div>
            <span>{{item.parseCreateTime}}</span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <CustomFooter @loginShow="()=> {$emit('loginShow')}"></CustomFooter>
    </div>
  </div>
</template>

<script>
import HomeData from "../../assets/datas/HomeData.json";
import CustomFooter from "../../components/globalComponents/Footer.vue";
import { getPcBannerList, getRecommendAndExtendCourse, getIndustryItemRelation, getCompanyArticle } from "../../assets/api/api";
import { openPhonePage } from "../../util/jumpPage";
export default {
  name: 'Home',
  components: {
    CustomFooter
  },
  data () {
    return {
      banner: [],
      allcourse: [],
      recommend: [],
      infomation: [],
      allcourseName: '',
      recommendName: '',
      allCourseLeftNavSelect: 0,
      allCourseTopNavSelect: 0,
      containerHeight: 0,
      isSpanHovered: false
    }
  },
  mounted () {
    this.fatchData()
    this.initScreenWidth(document.body.clientWidth)
    this.containerHeight = document.documentElement.clientHeight - 80
  },
  methods: {
    /**
     * 屏幕宽度小于960，跳转手机页面
     */
    initScreenWidth(clientWidth) {
      if(clientWidth < 960){
        openPhonePage()
      }
    },
    fatchData () {
      // this.banner = HomeData.bannerList
      // this.allcourse = HomeData.allcourse
      // this.recommend = HomeData.recommend
      this.allcourseName = HomeData.allcourseName
      this.recommendName = HomeData.recommendName
      this.getPcBannerList()
      this.getRecommendAndExtendCourse()
      this.getIndustryItemRelation()
    },
    getCompanyArticle () {
      this.infomation = []
      const params = {
        itemId: this.allcourse[this.allCourseLeftNavSelect].goodsItemsList[this.allCourseTopNavSelect].autoId
      }
      getCompanyArticle(params).then(res => {
        this.infomation = res.data
      }).catch((err) => {
      }).finally(() => {
      })
    },
    // 获取全部课程分类
    getIndustryItemRelation () {
      getIndustryItemRelation({}).then(res => {
        this.allcourse = res.data
        this.getCompanyArticle()
      }).catch((err) => {
      }).finally(() => {
      })
    },
    // 获取推荐课程信息
    getRecommendAndExtendCourse () {
      getRecommendAndExtendCourse({}).then(res => {
        this.recommend = res.data[0].goodsList
      }).catch((err) => {
      }).finally(() => {
      })
    },
    // 获取首页轮播图
    getPcBannerList () {
      getPcBannerList({}).then(res => {
        this.banner = res.data
      }).catch((err) => {
      }).finally(() => {
      })
    },
    spanHover(value) {
      this.isSpanHovered = value;
    },
    leftSelectNav (index) {
      this.allCourseLeftNavSelect = index
      this.allCourseTopNavSelect = 0
      this.getCompanyArticle()
    },
    topSelectNav (index) {
      this.allCourseTopNavSelect = index
      this.getCompanyArticle()
    },
    toDetails (item) {
      if (!localStorage.getItem('userId')) {
        this.$emit('loginShow')
        return
      }
      this.$router.push({ name: 'GoodsDetails', query: { courseId: item.autoId } })
    },
    toArticleDetails (item) {
      if (item.pageLink) {
        // 跳转外部网页
        window.open(item.pageLink)
        return
      }
      if (item.articleUrl) {
        this.$router.push({ name: 'ArticleDetails', query: { title: item.articleTitle, val: item.articleUrl } })
        return
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/.ant-carousel .slick-slide,
/deep/.ant-carousel .slick-slide div {
  height: 500px;
  overflow: hidden;
}
/deep/.ant-carousel {
  height: 500px;
  width: 100%;
}

.container {
  flex-direction: column;
  overflow-y: auto;
  min-height: 100%;
  background: #fff;
  .banner-img {
    width: 100%;
    object-fit: cover;
    height: 100%;
  }

  .label {
    color: rgb(0, 0, 0);
    font-weight: 700;
    font-style: normal;
    font-size: 18px;
    span {
      width: 4px;
      height: 27px;
      background-color: #2d78c5;
      border-radius: 3px;
      display: inline-block;
      margin-right: 10px;
    }
  }

  .recommend-course {
    box-sizing: border-box;
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0 25px 0;
    background: #fff;
    color: #666;
    position: relative;

    .recommend {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
    }

    .recommend-item {
      width: 260px;
      background: #fff;
      box-shadow: 0 3px 6px 3px rgba(0, 0, 0, 0.16);
      border-radius: 0 0 5px 5px;
      margin-bottom: 26px;
      margin-right: 53px;
      transition: all 0.25s ease-in;
      cursor: pointer;
      img {
        width: 100%;
        height: 173px;
        object-fit: cover;
      }

      .content {
        padding: 15px;
        box-sizing: border-box;
        .goods-name {
          margin: 0 0 5px;
          font-size: 16px;
          color: #555;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          font-weight: 700;
          width: 250px;
          display: inline-block;
        }
        .remarks {
          font-size: 14px;
          font-weight: 400;
          line-height: 17px;
          color: #666666;
          min-height: 34px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          margin-bottom: 10px;
        }

        .buy-number {
          color: #999999;
          font-size: 14px;
          font-weight: 400;
        }

        .money {
          font-size: 14px;
          font-weight: 400;
          color: #fd3f31;
        }
      }
    }

    .recommend :nth-of-type(4n) {
      margin-right: 0;
    }

    .recommend-item:hover {
      transform: translateY(-8px);
    }
  }

  .all-course {
    box-sizing: border-box;
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 50px;
    background: #fff;
    color: #666;
    position: relative;
    .course {
      margin-top: 25px;
      align-items: flex-start;
      .left {
        margin-right: 20px;
        .nav {
          height: 60px;
          line-height: 60px;
          font-size: 18px;
          text-align: center;
          background-color: #dae9f9;
          color: #2d78c5;
          border-left: 9px solid #2d78c5;
          border-radius: 5px;
          margin-bottom: 10px;
          width: 158px;
          font-weight: 500;
          /* 添加文本溢出和省略号 */
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        /*.nav:hover,*/
        /*.nav:hover {
          white-space: normal; !* 显示全部文本 *!
          overflow: visible;
        }*/

        .small-text-span {
          font-size: 18px; /* 设置初始字体大小 */
          transition: all 0s; /* 添加过渡效果，使字体缩放更平滑 */
        }

        .small-text-span:hover, .small-text-span.hovered {
          font-size: 12px; /* 缩小字体大小 */
        }
        .nav:hover::after {
          display: block;
        }
        .navSelect {
          background-color: #2d78c5;
          color: #ffffff;
        }
      }

      .right {
        flex: 1;
        .top-nav {
          span {
            -webkit-transition: all 0.3s ease-in-out;
            transition: all 0.3s ease-in-out;
            margin: 0 20px;
            text-align: center;
            font-size: 14px;
            color: #555;
            height: 30px;
            line-height: 30px;
            cursor: pointer;
          }

          .top-nav-select {
            color: #2d78c5;
            border-bottom: 1px solid #2d78c5;
          }
        }

        .recommend {
          display: flex;
          flex-wrap: wrap;
          margin-top: 20px;
        }

        .recommend-item {
          width: 240px;
          background: #fff;
          box-shadow: 0 3px 6px 3px rgba(0, 0, 0, 0.16);
          border-radius: 0 0 5px 5px;
          margin-bottom: 26px;
          margin-right: 20px;
          transition: all 0.25s ease-in;
          cursor: pointer;
          img {
            width: 100%;
            height: 173px;
            object-fit: fill;
          }

          .content {
            padding: 15px;
            box-sizing: border-box;
            .goods-name {
              margin: 0 0 5px;
              font-size: 14px;
              color: #555;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: break-all;
              font-weight: 700;
              width: 220px;
              display: inline-block;
            }
            .remarks {
              font-size: 10px;
              font-weight: 400;
              line-height: 17px;
              color: #bebebe;
              min-height: 34px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .buy-number {
              color: #bebebe;
              font-size: 10px;
              font-weight: 400;
            }

            .money {
              font-size: 10px;
              font-weight: 400;
              color: #fd3f31;
            }
          }
        }

        .recommend4n :nth-of-type(4n) {
          margin-right: 0;
        }

        .recommend3n :nth-of-type(3n) {
          margin-right: 0;
        }

        .recommend-item:hover {
          transform: translateY(-8px);
        }
      }

      .infomation {
        width: 240px;
        margin-top: 50px;
        box-shadow: 0 3px 6px 3px rgba(0, 0, 0, 0.16);
        box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.16);
        min-height: 50px;
        border-radius: 5px;
        padding: 0 9px;
        margin-right: 2px;
        margin-bottom: 2px;
        box-sizing: border-box;
        h5 {
          margin: 10px 0;
          font-size: 14px;
          color: #555;
          line-height: 30px;
        }

        .item {
          padding: 10px 0;
          border-top: 1px solid #b1b1b1;
          color: #555;
          cursor: pointer;
          div {
            width: 100%;
            font-size: 13px;
            line-height: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }

          span {
            font-size: 12px;
            line-height: 16px;
          }
        }

        .item:hover {
          color: #2d78c5;
        }
      }
    }
  }
}
</style>
